exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-background[data-v-72b9f112] {\n  background-color: #000000;\n  opacity: 0.8;\n  position: absolute;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72b9f112","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/atoms/ModalBackground.vue
// module id = q3Ys
// module chunks = 3